import { Box, Group, Paper, Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export default function SectionCard({
  title,
  subtitle,
  action,
  fill = false,
  children,
}: {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  /** Stretch the content to the card's full height, for a chart beside a taller card. */
  fill?: boolean;
  children: React.ReactNode;
}) {
  return (
    <Paper
      p="md"
      withBorder
      radius="md"
      style={fill ? { display: 'flex', flexDirection: 'column', height: '100%' } : undefined}
    >
      <Group justify="space-between" align="flex-start" wrap="wrap" gap="xs" mb="sm">
        <Stack gap={2}>
          <Text fw={FONT_WEIGHTS.semibold}>{title}</Text>
          {subtitle && (
            <Text size="textXs" c="dimmed">
              {subtitle}
            </Text>
          )}
        </Stack>
        {action}
      </Group>
      {fill ? <Box style={{ flex: 1, minHeight: 0 }}>{children}</Box> : children}
    </Paper>
  );
}
